import { ref, watch, defineComponent, computed } from "vue";
import { definePropType } from "@types-vue/props";
import ResourceItem from "./item-modular.vue";
import { handleResourceConfig, handleDownloadConfig, updateViewDialog } from "../config/dialog";
import { TabsType } from "../config/enums";
import store from "@/store";
export default defineComponent({
    name: "card-modular",
    components: {
        ResourceItem: ResourceItem
    },
    props: {
        listLoading: {
            type: definePropType(Boolean),
            default: false
        },
        cardList: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        },
        checkedRow: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var handleResourceEditConfig = function handleResourceEditConfig(row) {
            // 片段库资源修改
            if (activeTab.value === TabsType.FRAGMENT) {
                emit("click-row", row);
            } else {
                handleResourceConfig(row, "revise");
            }
        };
        var handleViewModel = function handleViewModel(row) {
            updateViewDialog({
                id: row.id,
                visible: true,
                preview_urls: row.preview_urls,
                name: row.name,
                type: row.type,
                skeleton_type: row.skeleton_type,
                file_list: row.file_list,
                file_meta: row.file_meta
            });
        };
        var cardIds = ref([]);
        var activeTab = computed(function() {
            return store.state.resource.activeTab;
        });
        var hideDownload = computed(function() {
            return activeTab.value !== TabsType.FRAGMENT;
        });
        watch(function() {
            return props.checkedRow;
        }, function(val) {
            cardIds.value = val;
        }, {
            immediate: true
        });
        var isCheckd = function(id) {
            return cardIds.value.some(function(item) {
                return item.id === id;
            });
        };
        var handleCheckConfig = function(item) {
            var index = cardIds.value.findIndex(function(val) {
                return val.id === item.id;
            });
            if (index !== -1) {
                cardIds.value.splice(index, 1);
            } else {
                cardIds.value.push(item);
            }
            emit("handleSelection", cardIds.value);
        };
        return {
            TabsType: TabsType,
            activeTab: activeTab,
            hideDownload: hideDownload,
            isCheckd: isCheckd,
            handleCheckConfig: handleCheckConfig,
            handleDownloadConfig: handleDownloadConfig,
            handleResourceConfig: handleResourceConfig,
            handleResourceEditConfig: handleResourceEditConfig,
            handleViewModel: handleViewModel
        };
    }
});
